import React from 'react';
import { Typography } from 'fronton-react';

export const PopularOrderButton = () => (
	<Typography variant="s" size="body_long" data-qa="popular-order-btn-content">
		Заказать
	</Typography>
);
